import React from 'react';
import { useTranslation } from 'react-i18next';
import * as Select from '@radix-ui/react-select';
import { FamilyMemberTypeahead, type FamilyMemberOption } from '@/components/family/FamilyMemberTypeahead';
import {
  PARENT_CHILD_RELATIONSHIP_OPTIONS,
  type ParentChildRelationshipTypeValue
} from '@/types/parent-child-relationship';

export interface AddFamilyMemberLinkExistingFieldsProps {
  isChild: boolean;
  isParent: boolean;
  isSpouse: boolean;
  linkOtherMemberId: string;
  onLinkOtherMemberIdChange: (id: string) => void;
  linkPcRelationshipType: ParentChildRelationshipTypeValue;
  onLinkPcRelationshipTypeChange: (v: ParentChildRelationshipTypeValue) => void;
  members: FamilyMemberOption[];
  isSubmitting: boolean;
}

const AddFamilyMemberLinkExistingFields: React.FC<AddFamilyMemberLinkExistingFieldsProps> = ({
  isChild,
  isParent,
  isSpouse,
  linkOtherMemberId,
  onLinkOtherMemberIdChange,
  linkPcRelationshipType,
  onLinkPcRelationshipTypeChange,
  members,
  isSubmitting
}) => {
  const { t } = useTranslation('screens');
  const { t: tForms } = useTranslation('forms');

  return (
    <div className="add-member-page__link-existing">
      <p className="add-flow-entry-hint">
        {isChild && t('addFlow.linkChildHint')}
        {isParent && t('addFlow.linkParentHint')}
        {isSpouse && t('addFlow.linkSpouseHint')}
      </p>
      <div className="add-flow-link-field">
        <FamilyMemberTypeahead
          value={linkOtherMemberId}
          onChange={onLinkOtherMemberIdChange}
          members={members}
          label={isChild ? t('addFlow.labelChild') : isParent ? t('addFlow.labelParent') : t('addFlow.labelSpouse')}
          placeholder={tForms('person.searchByName')}
          maxResults={8}
          disabled={isSubmitting}
          id="add-family-link-member"
        />
      </div>
      {(isChild || isParent) && (
        <div className="add-flow-link-field">
          <span className="person-edit-form__label" id="add-family-link-pc-type">
            {tForms('person.relationshipType')}
          </span>
          <Select.Root
            value={linkPcRelationshipType}
            onValueChange={(v) => onLinkPcRelationshipTypeChange(v as ParentChildRelationshipTypeValue)}
            disabled={isSubmitting}
          >
            <Select.Trigger className="form-select-trigger" aria-labelledby="add-family-link-pc-type">
              <Select.Value />
            </Select.Trigger>
            <Select.Portal>
              <Select.Content className="form-select-content" position="popper" sideOffset={4}>
                {PARENT_CHILD_RELATIONSHIP_OPTIONS.map((opt) => (
                  <Select.Item key={opt.value} value={opt.value} className="form-select-item">
                    <Select.ItemText>{opt.label}</Select.ItemText>
                  </Select.Item>
                ))}
              </Select.Content>
            </Select.Portal>
          </Select.Root>
        </div>
      )}
    </div>
  );
};

export default AddFamilyMemberLinkExistingFields;
